import React from 'react'

export const AdminPage = () => {
   return (
      <div className="AdminPage calc_minHeight">
         Admin Page
      </div>
   )
}
